<template lang="html">
	<div class="container">
		<h1 class="text"><span>4</span><span>0</span><span>4</span></h1>
	</div>
</template>

<script>
export default {
	name: 'FourOhFour'
}
</script>

<style scoped lang="scss">

@keyframes rotate {
	from {
		transform: rotate3d(1, -1, 1, 0deg);
	}
	to {
		transform: rotate3d(1, -1, 1, 360deg);
	}
}

.container {
	width: 100%;
	height: 100%;

	display: flex;
	align-items: center;
	justify-content: center;

	.text {
		font-size: 20vw;
		margin-bottom: 10vw;
		animation: rotate 10s infinite linear;

		span {
		}
	}
}
</style>
